import { v4 as uuidv4 } from 'uuid'; 
import Swal from 'sweetalert2';

export const keyId = () => uuidv4().toString().replace(/-/g, '')

export const generateMongoDBId = () => {
    const hexString = Array(24).fill(0)?.map(() => Math.floor(Math.random() * 16).toString(16)).join('');
    return hexString;
};

export const getUserIdFromToken = (token) => {
    try {
        if (!token) return null;
        
        // Split the token and get the payload part
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;

        // Replace URL-safe chars and create base64
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        
        // Decode base64 and convert to string
        const jsonPayload = decodeURIComponent(atob(base64).split('')?.map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        // Parse JSON and get _id
        const { _id } = JSON.parse(jsonPayload);
        return _id;
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

export const commaSeparatedStringToArray = (string) => {
    //console.log("klsnjdflkwdsjfliksfj", string)
    if(!string) return []
    return string && string?.split(',')?.map((x)=>x?.trim())
 }

 export const fullNameOrEmail =  (contact, bypassEmail) => {
    if(contact?.firstName && contact?.lastName) return `${contact?.firstName} ${contact?.lastName} `
    if(!bypassEmail && contact?.email) return contact?.email
    if(contact?.email) return contact?.email
    if(contact?.lastName) return contact?.lastName
    if(contact?.firstName) return contact?.firstName
    if(!bypassEmail && contact?._id) return contact?._id
    if(bypassEmail) return ""
    return "No Name Found"
 }
 export const addNameSwal = async({now = Date.now(), title, inputValue = ``, okFn = () => {}}) => {
    const { value: name } = await Swal.fire({
        title: title ||`Please enter a name or title`,
        input: "text",
        inputValue,
        showCancelButton: true,
        inputValidator: (value) => {
            if (!value) {
            return "Inserire un nome";
            }
        }
        });
        if (name) {
        okFn(name)
        }
    }